const tag = 'basic-gallery'
if (!customElements.get(tag)) {
  customElements.define(
    tag,
    class Gallery extends HTMLElement {
      swiper = null;
      constructor() {
        super();
      }

      connectedCallback() {
        const autoplay = this.hasAttribute('autoplay');
        this.swiper = new Swiper(this.querySelector(".swiper"), {
          draggable: true,
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: false,
          speed: autoplay ? 1000 : 500,
          loop: true,
          autoplay: autoplay ? { delay: 5000 } : false,
          breakpoints: {
            1024: {
              draggable: false,
            },
          },
          navigation: {
            nextEl: this.querySelector('.carousel__arrows .arrow--next'),
            prevEl: this.querySelector('.carousel__arrows .arrow--prev')
          },
          scrollbar: {
            el: this.querySelector('.carousel__progress-bar'),
          },
        });
      }
    }
  );
}
